module.exports = __webpack_public_path__ + "img/default_tab_bg.1a826f51.png";